import React, { FC, forwardRef } from "react";
import { CheckmarkSmallIcon, PlusIcon } from "../../../../icons";
import { TButtonProps, Button } from "../Button";

export interface ICompareButtonProps extends Omit<TButtonProps, "ref"> {
  active?: boolean;
}

const CompareButton: FC<ICompareButtonProps> = forwardRef<
  HTMLButtonElement,
  ICompareButtonProps
>(({ active, ...rest }, ref) => (
  <Button
    data-testid="Comparison__TestID"
    ref={ref}
    variant="icon"
    classes={{ root: active ? "active" : null }}
    {...rest}
  >
    {active ? <CheckmarkSmallIcon /> : <PlusIcon />}
  </Button>
));

export default CompareButton;
